module.exports = __webpack_public_path__ + "img/place-de-la-cite.cebf0f96.png";